import { UnderConstructionComponent } from "../../../components";

export const SettingReceptionEmailsIndexPage = () => {
  return (
    <div>
      <UnderConstructionComponent />
    </div>
  );
};
